export { default as Badge } from './Badge';
export type { IBadgeProps, BadgeVariant, BadgeSize } from './Badge';
